export const _en = {
    label: {
        label: "Label"
    },
    startTs: {
        label: "Start time"
    },
    endTs: {
        label: "End time"
    },
    vacation: {
        label: "Vacation"
    },
    isReserve: {
        label: "It is a reserve"
    },
    startSpecificReserve: {
        label: "Start of reserve"
    },
    finishSpecificReserve: {
        label: "End of reserve"
    }
};

export const _fr = {
    label: {
        label: "Libellé"
    },
    startTs: {
        label: "Date et heure de début"
    },
    endTs: {
        label: "Date et heure de fin"
    },
    vacation: {
        label: "Vacation"
    },
    isReserve: {
        label: "Est une réserve"
    },
    startSpecificReserve: {
        label: "Début réserve"
    },
    finishSpecificReserve: {
        label: "Fin réserve"
    }
};